import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import BEMHelper from '@ynap/bem-helper'
import { ScrollToTopOnMount as ScrollToTop } from '@ynap/scroll-to-top'

import RSVPForm from './RSVPForm'
import FormSkeleton from './FormSkeleton'

const bem = new BEMHelper('Events')

const Events = (props) => {
    const { messages, user, fetchUser, createGuestIdentity, updateUserSuccess, createFastUserSuccess, uberToken, userSummary, automaticMarketingConsent } = props

    const [isLoading, setIsLoading] = useState(true)

    const dispatch = useDispatch()

    const defaultInitialValues = automaticMarketingConsent ? { maMarketingConsent: 'true' } : undefined

    useEffect(() => {
        if (!uberToken) {
            dispatch(createGuestIdentity)
        }
    }, [])

    useEffect(() => {
        if (userSummary?.registrationStatus === 'RegisteredPerson' && !user) fetchUser()
        if (uberToken && (userSummary === null || user)) {
            setIsLoading(false)
        }
    }, [uberToken, userSummary, user])

    return (
        <section className={bem()}>
            <header className={bem('banner')}>
                <div className={bem('brand-logo')} />
                <h1 className={bem('title')}>{messages.event.title()}</h1>
            </header>
            <div className={bem('content')}>
                {updateUserSuccess || createFastUserSuccess ? (
                    <ScrollToTop>
                        <div className={bem('registration-success')}>
                            <h2 className={bem('success-title')}>{messages.event.successTitle()}</h2>
                            <p className={bem('success-message')}>{messages.event.successMessage()}</p>
                        </div>
                    </ScrollToTop>
                ) : (
                    <div className={bem('registration-form')}>
                        <p className={bem('description')}>{messages.event.description1()}</p>
                        <p className={bem('description')}>{messages.event.description2()}</p>
                        <ol className={bem('schedule')}>
                            {Object.keys(messages.event.schedule).map((eventPart) => {
                                const formattedDate = messages.event.schedule[eventPart].day()
                                const formattedTime = messages.event.schedule[eventPart].time()
                                return (
                                    <li key={`event-${formattedDate}-${formattedTime}`}>
                                        <span className={bem('event-date')}>{formattedDate}</span>
                                        <span className={bem('event-time')}>{formattedTime}</span>
                                    </li>
                                )
                            })}
                        </ol>
                        <p className={bem('location')}>{messages.event.location()}</p>
                        { isLoading ? <FormSkeleton /> : 
                        <RSVPForm
                            className={bem('form')}
                            initialValues={user ? user : defaultInitialValues}
                            {...props}
                        />}
                    </div>
                )}
            </div>
        </section>
    )
}

export default Events
